<div
  class="notes-container"
  [style.margin-top]="data?.marginTop"
  [style.margin-bottom]="data?.marginBottom || '12px'"
  [class.notes-container--border]="data?.border"
>
  <p class="note-line" *ngFor="let note of notes; trackBy: trackById">
    <span class="note-label">{{ note.label }} :-</span>
    {{ note.text }}
  </p>
</div>
